export interface HolidayDateSource {
    date: string;
    recurring: boolean;
}

export function projectRecurringDates(holidays: HolidayDateSource[], years: number[]): string[] {
    return holidays.flatMap((holiday) => {
        if (!holiday.recurring) return [holiday.date];
        const monthDay = holiday.date.slice(5);
        return years
            .map((year) => `${year}-${monthDay}`)
            .filter((candidate) => {
                const [y, m, d] = candidate.split('-').map(Number);
                const date = new Date(y, m - 1, d);
                return date.getMonth() === m - 1;
            });
    });
}
